import { makeAutoObservable, reaction } from "mobx";
import { useTelegram } from "../features/hooks";
import { logger } from "../features/logger";
import { AuthStore } from "./auth.store";
import { CartStore, CouseInCart } from "./cart.store";
import { ReceptionStore } from "./reception.store";
import UserStore from "./user.store";
import { getItem } from "../features/local-storage";
import bridge from "@vkontakte/vk-bridge";
import { VK_Metrics } from "../features/Metrics";
import config from "../features/config";

export default class RootStore {
  constructor() {
    logger.log(config.isDev ? 'development' : 'prod', 'root')
    makeAutoObservable(this)
    this.bootstrap()

    /**
     * Когда все загрузится можем
     * зайти в localstorage
     * и взять сохраненную корзину
     */
    reaction(
      () => this.reception.menu.loadMenu.state,
      val => {
        if(val === 'COMPLETED') {
          // вспоминаем что сохранили в локал стораге
          const savedCart = getItem<CouseInCart[]>('cartItems')
          // надо проверить есть ли сейчас это блюдо в меню
          if(savedCart?.length) {
            this.cart.items = [];
            savedCart.forEach((couseInCart) => {
              const isExistsOnMenu = this.reception.menu.allDishes.find((bludo) => 
                bludo.VCode === couseInCart.couse.VCode
              )
              // если есть то норм
              if(isExistsOnMenu) for (let i = 1; i <= couseInCart.quantity; i++) {
                this.cart.addCourseToCart(isExistsOnMenu)                
              }
            })
          }
        }
      }
    )
  }
  auth = new AuthStore(this)
  reception = new ReceptionStore(this)
  user = new UserStore(this)
  cart = new CartStore(this)
  vkMiniAppMetrics = new VK_Metrics()

  disposeOrgID = reaction(
    () => this.reception.OrgForMenu,
    (value, prevValue) => {
      if(prevValue !== value) {
        logger.log(`orgID changed from ${prevValue} to ${value}`, 'root')
        this.reception.employees.loadCooks.run(value)
        this.reception.menu.loadMenu.run(value)
        this.user.loadUserInfo.run(value, this.user.ID ?? 0)
      }
    }
  )

  bootstrap = async () => {
    this.whereWeAre()
    await this.reception.loadOrganizations.run();
    await this.auth.check();
    this.vkMiniAppMetrics.init(this.user.ID || '')
    if(this.auth.isFailed) {
      const orgId = this.reception.OrgForMenu
      this.reception.employees.loadCooks.run(orgId)
      this.reception.menu.loadMenu.run(orgId)
    }
  }

  whereWeAre = () => {
    const { isInTelegram } = useTelegram()
    if(isInTelegram()) {
      logger.log('мы в телеге', 'root')
      this.appType = 'TG_BROWSER'
    } else if (bridge?.isIframe() || bridge?.isWebView()) {
      logger.log('мы в VK', 'root')
      this.appType = 'VK'
    } else if (window.WebApp.initData !== null) {
      logger.log('мы в максе', 'root')
      this.appType = 'MAX'
    } else {
      logger.log('мы в браузере', 'root')
      this.appType = 'WEB_BROWSER'
    }
  }
  instance: AppInstance = 'UNKNOWN'
  set appType(type: AppInstance) {
    this.instance = type
  }
}




export const AppInstances = {
  UNKNOWN: "UNKNOWN",
  // MOBILE: "MOBILE",
  WEB_BROWSER: "WEB_BROWSER",
  TG_BROWSER: "TG_BROWSER",
  VK: "VK",
  MAX: "MAX",
} as const;
export type AppInstance = typeof AppInstances[keyof typeof AppInstances];

export const AppValues = {
  TG_BROWSER: 0,
  WEB_BROWSER: 1,
  VK: 2,
  UNKNOWN: 1,
  MAX: 3
} as const 